import { createBrowserWorkerTransport } from '../workers/client';
import { ProcessingError } from './errors';
import { ProcessingJobRunner } from './jobRunner';

let singleton: ProcessingJobRunner | undefined;

export function createBrowserProcessingRunner(): ProcessingJobRunner {
  if (typeof Worker === 'undefined') {
    throw new ProcessingError('processing.workerFailed', {
      reason: 'workerUnavailable',
    });
  }
  return new ProcessingJobRunner((processorId) => {
    const worker = new Worker(
      new URL('../workers/processing.worker.ts', import.meta.url),
      {
        type: 'module',
        name: `satr-${processorId}`,
      },
    );
    return createBrowserWorkerTransport(worker);
  });
}

/** Lazily creates one job runner per browser realm; each job still gets a disposable worker. */
export function getBrowserProcessingRunner(): ProcessingJobRunner {
  singleton ??= createBrowserProcessingRunner();
  return singleton;
}

export function disposeBrowserProcessingRunner(): void {
  singleton?.dispose();
  singleton = undefined;
}

if (import.meta.hot !== undefined) {
  import.meta.hot.dispose(disposeBrowserProcessingRunner);
}

